import { render, staticRenderFns } from "./ChordCircle.vue?vue&type=template&id=3a1f3116&scoped=true&"
import script from "./ChordCircle.vue?vue&type=script&lang=js&"
export * from "./ChordCircle.vue?vue&type=script&lang=js&"
import style0 from "./ChordCircle.vue?vue&type=style&index=0&id=3a1f3116&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a1f3116",
  null
  
)

export default component.exports